module.exports = __webpack_public_path__ + "img/empty-hookah.8b7400f.svg";